import { render, staticRenderFns } from "./IpsAvatar.vue?vue&type=template&id=2ba22ac9&scoped=true"
import script from "./IpsAvatar.vue?vue&type=script&lang=js"
export * from "./IpsAvatar.vue?vue&type=script&lang=js"
import style0 from "./IpsAvatar.vue?vue&type=style&index=0&id=2ba22ac9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba22ac9",
  null
  
)

export default component.exports